module.exports = __webpack_public_path__ + "img/A12a_19950037-010.63e7e430.jpg";